
/**
 * Represents a value dependency which describes a relationship between 
 * a model value configuration and an action based on certain conditions.
 */
export class ValueDependency {

  /** Unique identifier for the value dependency. */
  id?: string | null;

  /** Name to describe the dependency. */
  name?: string | null;

  /** Sort order of the dependency. */
  sortOrder?: number | null;

  /** Source model value identifier. */
  srcModelValueId?: string | null;

  /** Source model value grid column identifier. */
  srcMvGridColumnId?: string | null;

  /** Source grid row index (One based). */
  srcGridRow?: number | null;

  /** Source grid column index (One based). */
  srcGridCol?: number | null;

  /** Value to match on in the source. */
  srcValueMatchOn?: string | null;

  /** Action identifier to be triggered by the dependency. */
  actionId?: string | null;

  /** Operator identifier used in the dependency condition. */
  operatorId?: string | null;

  /** Dependency target model value identifier. */
  tgtModelValueId?: string | null;

  /** Dependency target model value grid column identifier. */
  tgtMvGridColumnId?: string | null;

  /** Dependency target grid row index (One based). */
  tgtGridRow?: number | null;

  /** Dependency target grid column index (One based). */
  tgtGridCol?: number | null;

  /** Indicates whether the dependency target should be set as disabled. */
  tgtIsDisabled?: boolean | null;

  /** Indicates whether the dependency target should be set as enabled. */
  tgtIsEnabled?: boolean | null;

  /** Indicates whether the dependency target should be hidden. */
  tgtIsHidden?: boolean | null;

  /** Indicates whether the dependency target should be shown. */
  tgtShow?: boolean | null;

  /** Value to reset the dependency target to. */
  tgtResetValue?: string | null;

  /** Indicates whether the dependency target should be reset. */
  tgtReset?: boolean | null;

  /** Value to set on the dependency target. */
  tgtValue?: string | null;

  /** Function to compute the dependency target value. */
  tgtValueFunc?: string | null;

  /** Indicates whether to replace all text matches. */
  txtReplaceAll?: boolean | null;

  /** Delimiter used to split text. */
  txtSplitDelimiter?: string | null;

  /** Group index for text replacement. */
  txtReplaceGroup?: number | null;

  /** Pattern used for text replacement. */
  txtReplacePattern?: string | null;

  /** Description name for the source */
  srcName?: string | null;

  /** Source variable name. */
  srcVarName?: string | null;

  /** Source variable name column. */
  srcVarNameColumn?: string | null;

  /** Description name for the source grid column */
  srcNameColumn?: string | null;

  /** Description name for the target */
  tgtName?: string | null;

  /** Dependency target variable name. */
  tgtVarName?: string | null;

  /** Dependency target variable name column. */
  tgtVarNameColumn?: string | null;

  /** Description name for the dependency target grid column */
  tgtNameColumn?: string | null;

  /** Action code associated with the dependency. */
  actionCode?: string | null;

  /** Operator code used in the dependency condition. */
  operatorCode?: string | null;

}



